import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const RegisterPage = () => {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        confirmPassword: "",
        name: "",
        surname: "",
        phone: "",
        city: "",
        state: "",
        address: "",
        postal_code: "",
        company_name: "",
        vat_number: "",
        termsAccepted: false,
    });
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const validateForm = () => {
        const { email, password, confirmPassword, phone, vat_number, termsAccepted } = formData;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;
        const phoneRegex = /^\d+$/;
        const vatNumberRegex = /^\d{11,}$/;

        if (!emailRegex.test(email)) return "Email non valida.";
        if (!passwordRegex.test(password)) return "La password deve avere almeno 8 caratteri, una lettera e un numero.";
        if (password !== confirmPassword) return "Le password non coincidono.";
        if (!phoneRegex.test(phone)) return "Il numero di telefono deve contenere solo cifre.";
        if (!vatNumberRegex.test(vat_number)) return "La partita IVA deve contenere almeno 11 cifre.";
        if (!termsAccepted) return "Devi accettare i Termini di servizio.";
        return null;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        const validationError = validateForm();
        if (validationError) {
            setError(validationError);
            return;
        }
        setIsLoading(true);
        try {
            const response = await fetch("/api/v1/auth/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    accept: "application/json",
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                navigate("/login");
            } else {
                const data = await response.json();
                setError(data.message || "Errore nella registrazione: Utente già esistente!");
            }
        } catch (err) {
            setError("Errore di connessione");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center bg-[#fbfef5] pt-10">
            <div className="w-full max-w-lg p-8 space-y-8">
                <h1 className="titolo-style mb-4 text-center">
                    <span
                        className="block text-[#94c41c]"
                        style={{
                            marginBottom: '0px',
                            display: 'block',
                            fontSize: '55px',
                            lineHeight: '1.2',
                        }}
                    >
                        Crea il tuo account
                    </span>
                </h1>

                <p className="text-gray-600 mb-8 text-2xl">
                    Registrati gratuitamente e accedi a tutti i nostri servizi.
                </p>

                {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

                <form onSubmit={handleSubmit} className="space-y-8">
                    <div className="form-group">
                        <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <input
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={formData.password}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <input
                            type="password"
                            name="confirmPassword"
                            placeholder="Conferma Password"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                            required
                        />
                    </div>

                    <div className="flex space-x-4">
                        <div className="w-1/2">
                            <input
                                type="text"
                                name="name"
                                placeholder="Nome"
                                value={formData.name}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                                required
                            />
                        </div>
                        <div className="w-1/2">
                            <input
                                type="text"
                                name="surname"
                                placeholder="Cognome"
                                value={formData.surname}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                                required
                            />
                        </div>
                    </div>

                    <div className="flex space-x-4">
                        <div className="w-1/2">
                            <input
                                type="text"
                                name="phone"
                                placeholder="Telefono"
                                value={formData.phone}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                                required
                            />
                        </div>
                        <div className="w-1/2">
                            <input
                                type="text"
                                name="city"
                                placeholder="Città"
                                value={formData.city}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                                required
                            />
                        </div>
                    </div>

                    <div className="flex space-x-4">
                        <div className="w-1/2">
                            <input
                                type="text"
                                name="state"
                                placeholder="Stato"
                                value={formData.state}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                                required
                            />
                        </div>
                        <div className="w-1/2">
                            <input
                                type="text"
                                name="address"
                                placeholder="Indirizzo"
                                value={formData.address}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                                required
                            />
                        </div>
                    </div>

                    <div className="flex space-x-4">
                        <div className="w-1/2">
                            <input
                                type="text"
                                name="postal_code"
                                placeholder="CAP"
                                value={formData.postal_code}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                                required
                            />
                        </div>
                        <div className="w-1/2">
                            <input
                                type="text"
                                name="vat_number"
                                placeholder="Partita IVA"
                                value={formData.vat_number}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                                required
                            />
                        </div>
                    </div>

                    {/* checkbox termini di servizio */}
                    <div className="flex justify-center items-center space-x-4 text-xl">
                        <input
                            type="checkbox"
                            name="termsAccepted"
                            checked={formData.termsAccepted}
                            onChange={handleChange}
                            className="h-4 w-4 text-[#94c41c] border-[#94c41c] rounded"
                        />
                        <label htmlFor="termsAccepted" className="text-xl text-gray-600">
                            Accetto i <span className="text-[#94c41c]">Termini di servizio</span>
                        </label>
                    </div>

                    <button
                        type="submit"
                        className={`w-full bg-[#94c41c] text-white py-4 px-8 rounded-full hover:bg-black transition-all duration-300 border-2 border-[#4a8e44] text-xl ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                        disabled={isLoading}
                        style={{ fontSize: '20px' }}
                    >
                        {isLoading ? "Registrazione..." : "Registrati"}
                    </button>

                    {/* Vai al login */}
                    <div className="text-center mt-4">
                        <span style={{ fontSize: '20px', color: 'black' }}>Sei già registrato? </span>
                        <a
                            href="/login"
                            className="text-xl text-[#94c41c] underline"
                            style={{ whiteSpace: 'nowrap' }}
                        >
                            Clicca qui
                        </a>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RegisterPage;
